<template>
  <!-- <AllCountries /> -->
 
    
      <router-link to="/"></router-link> 
      <router-link to="/:code"></router-link>
      <!-- <router-link to="/brazil">Brazil</router-link> -->
   
   <router-view />
</template>

<script>
// import AllCountries from './components/AllCountries.vue'

// export default {
//   name: 'App',
//   components: {
//     AllCountries
//   }
// }
</script>


